<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'informes' }">{{
                $t("informes")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{$t('retiradas')}}
            </li>
          </ol>
        </nav>
      </div>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <!--<div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="getFacturasEmitida()"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label
                  ><strong>{{ $t("fechaInicio") }}</strong></label
                >
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label
                  ><strong>{{ $t("fechaFin") }}</strong></label
                >
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <label>&nbsp;</label>
              <div class="form-group">
                <button class="btn btn-primary" @click="getFacturasEmitida()">
                  <i class="fa fa-refresh" v-if="loading"></i>
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      

      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-12  text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i> {{$t('fecha')}}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{$t('fecha')}}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarOperario"
                      @click="sortedArrayASC(2), (ordenarOperario = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{$t('operario')}}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2), (ordenarOperario = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{$t('operario')}}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarImporte"
                      @click="sortedArrayASC(3), (ordenarImporte = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{$t('importe')}}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(3), (ordenarImporte = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{$t('importe')}}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in dateInform">
                  <td>{{ obj.fecha | parseDateMin }}</td>
                  <td>{{ obj.nameWorker }}</td>
                  <td align="right">{{ obj.amount | currency }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td colspan="2" class="table-success">
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td class="text-right">
                    <strong>
                      {{ getTotalVentas | currency }}
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayFacturasEmitidasEnEsteRangoDeFecha") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Datetime from "vue-datetime";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import { mapState } from 'vuex';

export default {
  name: "Retiradas",

  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", "Retiradas");
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Datetime]: Datetime,
    [Option.name]: Option,
    CabeceraInformes
  },
  data() {
    return {
      loading: null,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      listBusinesses: [],
      idBusiness: 0,
      idTpv: -1,
      data: [""],
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      indice: 0,

      //ORDEN
      ordenarFecha: 0,
      ordenarOperario: 0,
      ordenarImporte: 0,

      respuesta: true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {

      let idTpvAMandar = "";

      if (this.idTpv == -1) {
          idTpvAMandar = 0;
      } else {
          idTpvAMandar = this.idTpv == undefined ? 0 : this.idTpv;
      }

      return (
        this.$store.getters.apiUrl +
        "/sales/exportRetiradas/PDF?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        idTpvAMandar +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {

      let idTpvAMandar = "";

      if (this.idTpv == -1) {
          idTpvAMandar = 0;
      } else {
          idTpvAMandar = this.idTpv == undefined ? 0 : this.idTpv;
      }
      
      return (
        this.$store.getters.apiUrl +
        "/sales/exportRetiradas/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        idTpvAMandar +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalVentas() {
      let xtotal = 0;

      this.dateInform.forEach(function(x) {
        xtotal += x.amount;
      });

      return xtotal;
    },
  },
  methods: {
    cambioBusiness(idBusinessData, listTpv) {
        if (listTpv) {
            this.listTpv = listTpv;
        }
        this.loading = Loading.service({ text: "Cargando..." });
        this.idBusiness = idBusinessData;
        this.idTpv = -1;
        this.list = [];
        this.cambioTpv()
    },
    emitirConsulta() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.getFacturasEmitida();
    },
    cambioTpv(idTpvData, filtrar) {

      if (idTpvData != undefined) {
          this.idTpv = idTpvData;
      }
      this.idTpv=idTpvData;
      this.emitirConsulta();
    },
    cambioHora(dates) {
        this.datefrom = dates[0]
        this.dateto = dates[1]
    },
    sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareFecha(a, b) {
            if (a.fecha < b.fecha) return -1;
            if (a.fecha > b.fecha) return 1;
            return 0;
          }

          return this.dateInform.sort(compareFecha);

        case 2:
          this.ordenarOperario = 1;

          function compareWorker(a, b) {
            if (a.nameWorker.toUpperCase() < b.nameWorker.toUpperCase())
              return -1;
            if (a.nameWorker.toUpperCase() > b.nameWorker.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareWorker);

        case 3:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.importe < b.importe) return -1;
            if (a.importe > b.importe) return 1;
            return 0;
          }

          return this.dateInform.sort(compareImporte);
      }
    },
    sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareFecha(a, b) {
            if (a.fecha > b.fecha) return -1;
            if (a.fecha < b.fecha) return 1;
            return 0;
          }

          return this.dateInform.sort(compareFecha);

        case 2:
          this.ordenarOperario = 0;

          function compareOperario(a, b) {
            if (a.nameWorker > b.nameWorker) return -1;
            if (a.nameWorker < b.nameWorker) return 1;
            return 0;
          }

          return this.dateInform.sort(compareOperario);

        case 3:
          this.ordenarDate = 0;

          function compareImporte(a, b) {
            if (a.importe > b.importe) return -1;
            if (a.importe < b.importe) return 1;
            return 0;
          }

          return this.dateInform.sort(compareImporte);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.getTpv();
          //vm.getFacturasEmitida();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTpv() {
      this.listTpv = [];

      var config = {
          params: {
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function(response) {
              if (response.data.response) {
                  vm.listTpv = response.data.result;
                  if (vm.listTpv.length > 0) {
                      vm.idTpv = -1;
                      vm.getFacturasEmitida();
                  }
              }
          })
          .catch(function(error) {
              console.log(error);
          })
          .finally((_) => {
              vm.loading.close();
          });
    },
    getFacturasEmitida() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t('ups'),
          text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t('ups'),
            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          let idTpvAMandar = "";
          if (this.idTpv == -1) {
              idTpvAMandar = 0;
          } else {
              idTpvAMandar = this.idTpv == undefined ? 0 : this.idTpv;
          }

          var config = {
            params: {
              idTpv: idTpvAMandar,
              idBusiness: this.idBusiness,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "sales/getRetiradas", config)
            .then(function(response) {
              if (response.data.response) {
                vm.dateInform = response.data.result;

                vm.respuesta = true;
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                  swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                  });
                  vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t('atencion'),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Retiradas.vue